// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { withDataFetching } from 'shared/helpers/dataFetching';
import { connect } from 'react-redux';

// redux store
import {
  getMenuData,
  getSSRHeaders,
  isMenuFetching as _isMenuFetching,
} from 'shared/store/app/selectors';
import {
  fetchMenuDataV2 as _fetchMenuData,
  resolveMenuAPI as _resolveMenuAPI,
} from 'shared/store/app/services';

// defs
import { IHeadersObject } from 'global';

interface IApiStateProps {
  isMenuFetching: boolean;
  menuData: any;
  cookies: {
    [key: string]: string;
  };
  ssrHeaders: IHeadersObject;
  shouldCallMenuApi?: boolean;
}

interface IApiDispatchProps {
  fetchMenuData: typeof _fetchMenuData;
  resolveMenuAPI: typeof _resolveMenuAPI;
}

interface IApiProps extends IApiStateProps, IApiDispatchProps {
  children: React.ReactNode;
  placeholder: React.ReactNode;
}

function Api({ children, placeholder, isMenuFetching = true }: IApiProps) {
  if (isMenuFetching) {
    return <>{placeholder}</>;
  }

  return <>{children}</>;
}

const mapStateToProps = (state: any) => ({
  isMenuFetching: _isMenuFetching(state),
  menuData: getMenuData(state),
  ssrHeaders: getSSRHeaders(state),
});

const mapDispatchToProps = {
  fetchMenuData: _fetchMenuData,
  resolveMenuAPI: _resolveMenuAPI,
};

const fetchData = ({
  shouldCallMenuApi = true,
  fetchMenuData,
  menuData,
  resolveMenuAPI,
}: IApiProps) => {
  if (isEmpty(menuData) === false) {
    return Promise.resolve();
  }

  const promises = [];

  if (shouldCallMenuApi === false) resolveMenuAPI();
  promises.push(isEmpty(menuData) && shouldCallMenuApi ? fetchMenuData() : Promise.resolve());

  return Promise.all(promises);
};

export default connect<IApiStateProps, IApiDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(withDataFetching(fetchData)(memo(Api)));
